import React from 'react';
import { normalizePremiumFolderData } from '../../../utils/normalizePremiumFolderData';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import PremiumGallery from '@wix/da-ds/pkg/Icons/24x24/PremiumGallery';
import EyeDisc2 from '@wix/da-ds/pkg/Icons/16x16/EyeDisc2';
import PromoBadge from '@wix/da-ds/pkg/Badges/PromoBadge';
import { useSubscriptionTier } from '../../../utils/hooks/useSubscriptionTier';
const IndicatorForDeviationThumb = ({ deviation, className })=>{
    var _deviation;
    const { isPremium, isPaidFolder, isWatchToAccess } = normalizePremiumFolderData((_deviation = deviation) === null || _deviation === void 0 ? void 0 : _deviation.premiumFolderData);
    const { isInTier } = useSubscriptionTier(deviation);
    let indicator;
    if (isPremium) {
        if (isPaidFolder) {
            indicator = /*#__PURE__*/ React.createElement(PremiumGallery, {
                size: IconSize.SMALL
            });
        } else if (isWatchToAccess) {
            indicator = /*#__PURE__*/ React.createElement(EyeDisc2, {
                size: IconSize.SMALL
            });
        }
    } else if (isInTier) {
        indicator = /*#__PURE__*/ React.createElement(PromoBadge, {
            badgeType: "tier",
            size: 16
        });
    }
    return indicator ? /*#__PURE__*/ React.createElement("div", {
        className: className
    }, indicator) : null;
};
IndicatorForDeviationThumb.displayName = 'IndicatorForDeviationThumb';
export default IndicatorForDeviationThumb;
